module.exports = __webpack_public_path__ + "static/media/capstone_permissions.1da82482.yaml";